import { GatsbyImage } from "gatsby-plugin-image";
import { useEffect, useRef, useState } from "react";
import useIntersectionObserver from "../../utils/hooks/useIntersectionObserver";

const Image = ({
  item,
  alt,
  className,
  fullHeight,
  fullWidth,
  lazy,
  onClick,
  style,
}) => {
  const [shouldShow, setShouldShow] = useState(!lazy);
  const ref = useRef();
  // lazy should always be statically set for each component
  if (lazy) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entry = useIntersectionObserver(ref, { rootMargin: "50%" });
    const isVisible = entry?.isIntersecting;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (isVisible) {
        setShouldShow(true);
      }
    }, [isVisible]);
  }
  const commonImageProps = {
    style: {
      height: fullHeight ? "100%" : "auto",
      width: fullWidth ? "100%" : "auto",
      ...style,
    },
    alt,
    className,
    onClick,
  };

  return item.imageData ? (
    <GatsbyImage
      image={item.imageData}
      placeholder="blurred"
      {...commonImageProps}
    />
  ) : (
    <img
      ref={ref}
      src={shouldShow ? item.imagePublicURL : null}
      {...commonImageProps}
      alt={alt}
    />
  );
};

export default Image;
